import { z } from "zod";

export type PostMessageResponse = z.infer<typeof PostMessageResponseSchema>;
export const PostMessageResponseSchema = z.object({
  status: z.number(),
  message: z.string(),
  message_id: z.string(),
});
